







export default {
  name: 'SentSimpleIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }

}
